import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Stack,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
  TextField,
  Button,
} from '@mui/material';
import GlobalWrapper from '../../../../../components/Wrapper/GlobalWrapper';
import { DeleteButton, LogButton, SaveButton, ViewButton } from '../../../../../components/mui/Buttons/Buttons';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { useDispatch, useSelector } from 'react-redux';
import Loader3D from '../../../../../components/Loader/Loader3D';
import {
  getDataForCrdAdmissionRegister,
  getTotalsessions,
  updateTotalSessions,
} from '../../../../../redux/features/CRDslice';
import { Form, FormikProvider, useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react/dist/iconify.js';

const SubjectAndTotalsession = ({ data, leadId, courseEnrollmentId, isDisable, dispatchParams, crm,apiCall }) => {
  const [open, setOpen] = useState(false);

  const { loading, sesssioncount } = useSelector((state) => state.crd);

  const [editableSessions, setEditableSessions] = useState({});
  const [focusedFieldId, setFocusedFieldId] = useState(null);

  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const headers = [
    'Subject',
    'Total Session',
    'Completed Sessions',
    'First Session Scheduled Date',
    'Last Session Scheduled Date',
    'Preference Status',
    'Action',
  ];

  useEffect(() => {
    if (open) {
      dispatch(getTotalsessions(courseEnrollmentId));
    }
  }, [open]);

  useEffect(() => {
    if (sesssioncount && sesssioncount.length > 0) {
      const sessionMap = {};
      sesssioncount.forEach((item) => {
        sessionMap[item.subject_enrollment_id] = item.total_sessions;
      });
      setEditableSessions(sessionMap);
    }
  }, [sesssioncount]);

  const formik = useFormik({
    initialValues: {
      subject_enrollment_id: '',
      sessionCount: '',
    },
    // onSubmit: (values, { resetForm }) => {
    //   dispatch(updateTotalSessions(values)).then((res) => {
    //     if (res.payload.status === "success") {
    //       enqueueSnackbar(res.payload.message, { variant: "success" });
    //       setOpen(false);
    //       resetForm();
    //     } else {
    //       enqueueSnackbar(res.payload.message, { variant: "error" });
    //     }
    //   });
    // },
  });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 13,
      border: '1px solid #ccc',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      border: '1px solid #ccc',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  return (
    <GlobalDialog
      title="Subjects And Total Sessions"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={'md'}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)} disabled={isDisable}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Table
                  aria-label="simple table"
                  sx={{
                    border: '1px solid #ccc',
                    borderCollapse: 'collapse',
                    marginTop: 2,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {headers.map((header, index) => (
                        <StyledTableCell key={index} align="center">
                          {header}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sesssioncount?.map((row) => (
                      <StyledTableRow key={row.subject_enrollment_id}>
                        <StyledTableCell align="center">{row.subject_name}</StyledTableCell>
                        <StyledTableCell align="center">
                          <TextField
                            size="small"
                            type="number"
                            sx={{
                              width: '80px',
                            }}
                            value={editableSessions[row.subject_enrollment_id] || ''}
                            inputRef={(el) => {
                              if (row.subject_enrollment_id === focusedFieldId) el?.focus();
                            }}
                            onFocus={() => setFocusedFieldId(row.subject_enrollment_id)}
                            onChange={(e) => {
                              setEditableSessions((prev) => ({
                                ...prev,
                                [row.subject_enrollment_id]: e.target.value,
                              }));
                            }}
                            disabled={!crm}
                            inputProps={{ min: 0 }}
                          />
                        </StyledTableCell>

                        <StyledTableCell align="center">{row.completed_sessions}</StyledTableCell>
                        <StyledTableCell align="center">
                          {row.first_session_date === null ? 'No Data' : row.first_session_date}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.last_session_date === null ? 'No Data' : row.last_session_date}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {row.preference_status === 'true' ? (
                            <Button>
                              <Icon icon="teenyicons:tick-circle-solid" width="30" height="30" color="green" />
                            </Button>
                          ) : (
                            <Button>
                              <Icon icon="gridicons:cross-circle" width="30" height="30" color="red" />
                            </Button>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <Stack direction="row" spacing={1}>
                            <Button
                              sx={{
                                px: '5px',
                                background: 'linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))',
                                color: '#fff',
                                '&:hover': {
                                  background:
                                    'linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))',
                                },
                              }}
                              size="small"
                              disabled={!crm}
                              onClick={() => {
                                const payload = {
                                  subject_enrollment_id: row.subject_enrollment_id,
                                  sessionCount: Number(editableSessions[row.subject_enrollment_id]),
                                };
                                dispatch(updateTotalSessions(payload)).then((res) => {
                                  if (res.payload.status === 'success') {
                                    enqueueSnackbar(res.payload.message, {
                                      variant: 'success',
                                    });
                                    // setOpen(false);
                                    dispatch(getTotalsessions(courseEnrollmentId)); // Refresh list
                                    if(apiCall){
                                      dispatch(apiCall(dispatchParams));
                                    }else{
                                      dispatch(getDataForCrdAdmissionRegister(dispatchParams));
                                    }
                                  } else {
                                    enqueueSnackbar(res.payload.message, {
                                      variant: 'error',
                                    });
                                  }
                                });
                              }}
                            >
                              Save
                            </Button>
                          </Stack>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </Form>
            </FormikProvider>
          )}
        </>
      }
    />
  );
};

export default SubjectAndTotalsession;
